import React from 'react'


export default class About extends React.Component {
    render() {
        return (
            <div>
                <h2>CMAQ</h2>

                <p>This is to help convert our NASA project CrIS data into a format others can use.</p>
            </div>
        );
    }
}
